import createReducer from './createReducer';
import {
  OPEN_WHATS_NEW_MODAL,
  CLOSE_WHATS_NEW_MODAL,
} from '../actions/whatsNewModal';

const initialState = {
  isOpen: false,
};

const handlers = {};

handlers[OPEN_WHATS_NEW_MODAL] = state => ({
  ...state,
  isOpen: true,
});

handlers[CLOSE_WHATS_NEW_MODAL] = state => ({
  ...state,
  isOpen: false,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/whatsNewModal.js